import { useWeb3React } from '@web3-react/core';
import { Web3Provider } from '@ethersproject/providers';
import useSWR from 'swr';
import { formatEther } from '@ethersproject/units';
import { useEffect } from 'react';

const fetcher =
  (library: any) =>
  (...args: any) => {
    const [method, ...params] = args;
    return library[method](...params);
  };

const NavbarWalletBalance = () => {
  const { account, library } = useWeb3React<Web3Provider>();
  const { data: balance, mutate } = useSWR(['getBalance', account, 'latest'], {
    fetcher: fetcher(library)
  });

  useEffect(() => {
    // listen for changes on an Ethereum address
    library?.on('block', () => {
      mutate(undefined, true);
    });
    // remove listener when the component is unmounted
    return () => {
      library?.removeAllListeners('block');
    };
    // trigger the effect only on component mount
  }, []);

  if (!balance) {
    return <>...</>;
  }
  return <>{parseFloat(formatEther(balance)).toPrecision(4)} BNB</>;
};

export default NavbarWalletBalance;
